import { isEmpty } from 'lodash'
import React, { useState } from 'react'
import { Form, InputGroup, InputGroupAddon, Input, Button } from 'reactstrap'
import Loading from '../../Loading/Loading'
import Comment from './Comment'

import './PlanComments.css'

const PlanComments = ({ comments, loading, onAddComment }) => {
    const [comment, setComment] = useState('')

    return (
        <div className="plan-comments">
            <Form
                onSubmit={(e) => {
                    e.preventDefault()
                    onAddComment(comment)
                }}
            >
                <InputGroup className="flex-row-reverse w-100">
                    <InputGroupAddon addonType="prepend">
                        <Button
                            className="plan-comments__comment-button"
                            disabled={loading}
                        >
                            ارسال
                        </Button>
                    </InputGroupAddon>
                    <Input
                        placeholder="نظر خود را بنویسید"
                        onChange={(e) => setComment(e.target.value)}
                        disabled={loading}
                    />
                </InputGroup>
            </Form>
            {loading ? (
                <Loading isImage size="md" />
            ) : (
                !isEmpty(comments) &&
                comments.map((comment, index) => (
                    <Comment key={index} {...comment} />
                ))
            )}
        </div>
    )
}

export default PlanComments
